import {
  MenuResponseScheme,
  SubscribeListScheme,
  TopFansListScheme,
} from '@/types/channel/menu/menu.schema';
import {NODECommonApi, PHPCommonApi} from '@/api/channel/common';

export const getStationSidebarMenuList = (streamerId: string) => {
  return NODECommonApi.get<MenuResponseScheme>(`/${streamerId}/menu`);
};

export const getStationTopFanList = (streamerId: string) => {
  return NODECommonApi.get<TopFansListScheme[]>(
    `/${streamerId}/topfans/detail`,
  );
};

export const getStationSubscriptionList = (
  streamerId: string,
  type: 'gift' | 'acc',
) => {
  return NODECommonApi.get<SubscribeListScheme[]>(
    `/${streamerId}/subscribe-${type}/detail`,
  );
};

export const getCreateWriteAuthMenuList = (
  streamerId: string,
  bbsId: number,
) => {
  return PHPCommonApi.get(
    `/${streamerId}/title/create?bbs_no=${bbsId ? bbsId : ''}`,
  );
};
